export const buildNumber = '20260320.5';
export const version = 'main';
export const latestCommit = '7936c799ba0dab0cb7cd87e0d006cd5244b9f8df';
